import { Component, h } from "@lukekaalim/act"
import { InvitationID } from "../../defs/invitation"
import { HttpApi, NetworkClient } from "@kosmod/pancake"
import { gamesAPI, GamesClient } from "../../defs"
import { AuthState, useGamesState } from "../../hooks"
import { useAsync } from "@kosmod/kit"
import { html } from "@lukekaalim/act-web"

export type InvitationPageProps = {
  invitationSecret: string,
  invitationId: InvitationID,

  clients: {
    games: GamesClient,
    auth: AuthState
  }
}

export const InvitationPage: Component<InvitationPageProps> = ({ invitationSecret, invitationId, clients }) => {
  if (clients.auth.authority === 'unknown')
    return 'loading'

  if (clients.auth.authority !== 'user')
    return `You must be logged in to accept an invitation to a game`

  const { result: invitation } = useAsync(async () => {
    const { invitations: [invitation] } = await clients.games.invitation.GET({ invitationId, gameId: null }, null, {
      'invitation-secret': invitationSecret
    });
    return invitation
  }, [])

  if (!invitation)
    return `loading invitation`

  const games = useGamesState(clients.games)

  return [
    `Hi, ${invitation.addressedTo}.`,
    `You have been invited to ${invitation.gameName}`,
    h(html.button, { onClick() {
      games.acceptInvitation(invitation.game, invitation.id, invitationSecret)
    } }, 'Accept')
  ]
}
